import React, { useMemo } from 'react'
import { keys, map } from 'lodash'
import PropTypes from 'prop-types'

import {
  computeTextDescriptorHighlights,
  handleAiHighlightStrategy,
} from '../../helpers'
import { StyledTextDescriptorContainer } from '../styled'

import AiHighlightDecoratedComponent from './ai-highlight-decorated-component'
import RichTextHighlightingInput from './rich-text-highlighting-input'

const TextDescriptor = ({ highlights, value, prefix }) => {
  const mappedTextDescriptorValuesToHighlightKeys = useMemo(
    () => computeTextDescriptorHighlights(prefix, value),
    [prefix, value],
  )

  const highlightingKeys = useMemo(
    () => keys(mappedTextDescriptorValuesToHighlightKeys),
    [mappedTextDescriptorValuesToHighlightKeys],
  )

  return (
    <StyledTextDescriptorContainer>
      {map(highlightingKeys, highlightKey => (
        <RichTextHighlightingInput
          key={highlightKey}
          value={mappedTextDescriptorValuesToHighlightKeys[highlightKey]}
          highlights={highlights[highlightKey] || []}
          highlightStrategy={handleAiHighlightStrategy}
          decoratorComponent={AiHighlightDecoratedComponent}
          isReadOnly
        />
      ))}
    </StyledTextDescriptorContainer>
  )
}

TextDescriptor.propTypes = {
  value: PropTypes.arrayOf(PropTypes.string).isRequired,
  highlights: PropTypes.object,
  prefix: PropTypes.string.isRequired,
}

TextDescriptor.defaultProps = {
  highlights: {},
}

export default TextDescriptor
